module.exports = "{\n  Enums(keys: [\"Region\"])\n}\n"